import * as React from 'react';
import { SVGProps } from 'react';

const SvgLockOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={38}
    fill="none"
    stroke="#A2A9AD"
    {...props}
  >
    <rect
      width={23.214}
      height={19.357}
      x={5.75}
      y={13.5}
      strokeWidth={2.5}
      rx={1.75}
    />
    <path
      strokeWidth={2.8}
      d="M11.25 12.286V6.82c.107-1.714 1.607-5.142 6.107-5.142 5.464 0 6.429 3.535 6.429 5.142v5.465"
    />
  </svg>
);
export default SvgLockOutline;
